import { InsurancePolicyParticipantDto } from 'shared/api/insurance'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

import { InsuranceInsuredPerson } from '../model/types'

export const mapInsuredPersons = (
  participants: InsurancePolicyParticipantDto[] | undefined,
): InsuranceInsuredPerson[] =>
  (participants || []).map((participant) => ({
    fullName: participant.full_name,
    birthDate: dateFormat(participant.date_birth, DATE_FORMAT_LIST.FULL_DATE),
    passportNumber: `${participant.passport_series || ''}${participant.passport_number}`,
    citizenship: participant.citizenship,
  }))
